// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/site_contact/v1/site_contact.proto (package fingertip.creator.site_contact.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { BulkCreateSiteContactsRequest, BulkCreateSiteContactsResponse, CreateSiteContactAddressRequest, CreateSiteContactAddressResponse, CreateSiteContactRequest, CreateSiteContactResponse, DeleteSiteContactAddressRequest, DeleteSiteContactAddressResponse, DeleteSiteContactRequest, DeleteSiteContactResponse, ExportSiteContactsRequest, ExportSiteContactsResponse, GetSiteContactOverviewRequest, GetSiteContactOverviewResponse, GetSiteContactPublicRequest, GetSiteContactPublicResponse, GetSiteContactRequest, GetSiteContactResponse, GetSiteContactsRequest, GetSiteContactsResponse, SendSiteContactDetailsPublicRequest, SendSiteContactDetailsPublicResponse, UnsubscribeSiteContactPublicRequest, UnsubscribeSiteContactPublicResponse, UpdateSiteContactAddressRequest, UpdateSiteContactAddressResponse, UpdateSiteContactPublicRequest, UpdateSiteContactPublicResponse, UpdateSiteContactRequest, UpdateSiteContactResponse } from "./site_contact_pb.js";

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.GetSiteContactPublic
 */
export const getSiteContactPublic = {
  localName: "getSiteContactPublic",
  name: "GetSiteContactPublic",
  kind: MethodKind.Unary,
  I: GetSiteContactPublicRequest,
  O: GetSiteContactPublicResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.GetSiteContact
 */
export const getSiteContact = {
  localName: "getSiteContact",
  name: "GetSiteContact",
  kind: MethodKind.Unary,
  I: GetSiteContactRequest,
  O: GetSiteContactResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.GetSiteContacts
 */
export const getSiteContacts = {
  localName: "getSiteContacts",
  name: "GetSiteContacts",
  kind: MethodKind.Unary,
  I: GetSiteContactsRequest,
  O: GetSiteContactsResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.UpdateSiteContactPublic
 */
export const updateSiteContactPublic = {
  localName: "updateSiteContactPublic",
  name: "UpdateSiteContactPublic",
  kind: MethodKind.Unary,
  I: UpdateSiteContactPublicRequest,
  O: UpdateSiteContactPublicResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.SendSiteContactDetailsPublic
 */
export const sendSiteContactDetailsPublic = {
  localName: "sendSiteContactDetailsPublic",
  name: "SendSiteContactDetailsPublic",
  kind: MethodKind.Unary,
  I: SendSiteContactDetailsPublicRequest,
  O: SendSiteContactDetailsPublicResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.UpdateSiteContact
 */
export const updateSiteContact = {
  localName: "updateSiteContact",
  name: "UpdateSiteContact",
  kind: MethodKind.Unary,
  I: UpdateSiteContactRequest,
  O: UpdateSiteContactResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.UnsubscribeSiteContactPublic
 */
export const unsubscribeSiteContactPublic = {
  localName: "unsubscribeSiteContactPublic",
  name: "UnsubscribeSiteContactPublic",
  kind: MethodKind.Unary,
  I: UnsubscribeSiteContactPublicRequest,
  O: UnsubscribeSiteContactPublicResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.CreateSiteContact
 */
export const createSiteContact = {
  localName: "createSiteContact",
  name: "CreateSiteContact",
  kind: MethodKind.Unary,
  I: CreateSiteContactRequest,
  O: CreateSiteContactResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.DeleteSiteContact
 */
export const deleteSiteContact = {
  localName: "deleteSiteContact",
  name: "DeleteSiteContact",
  kind: MethodKind.Unary,
  I: DeleteSiteContactRequest,
  O: DeleteSiteContactResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.GetSiteContactOverview
 */
export const getSiteContactOverview = {
  localName: "getSiteContactOverview",
  name: "GetSiteContactOverview",
  kind: MethodKind.Unary,
  I: GetSiteContactOverviewRequest,
  O: GetSiteContactOverviewResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.BulkCreateSiteContacts
 */
export const bulkCreateSiteContacts = {
  localName: "bulkCreateSiteContacts",
  name: "BulkCreateSiteContacts",
  kind: MethodKind.Unary,
  I: BulkCreateSiteContactsRequest,
  O: BulkCreateSiteContactsResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.CreateSiteContactAddress
 */
export const createSiteContactAddress = {
  localName: "createSiteContactAddress",
  name: "CreateSiteContactAddress",
  kind: MethodKind.Unary,
  I: CreateSiteContactAddressRequest,
  O: CreateSiteContactAddressResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.UpdateSiteContactAddress
 */
export const updateSiteContactAddress = {
  localName: "updateSiteContactAddress",
  name: "UpdateSiteContactAddress",
  kind: MethodKind.Unary,
  I: UpdateSiteContactAddressRequest,
  O: UpdateSiteContactAddressResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.DeleteSiteContactAddress
 */
export const deleteSiteContactAddress = {
  localName: "deleteSiteContactAddress",
  name: "DeleteSiteContactAddress",
  kind: MethodKind.Unary,
  I: DeleteSiteContactAddressRequest,
  O: DeleteSiteContactAddressResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_contact.v1.SiteContactService.ExportSiteContacts
 */
export const exportSiteContacts = {
  localName: "exportSiteContacts",
  name: "ExportSiteContacts",
  kind: MethodKind.Unary,
  I: ExportSiteContactsRequest,
  O: ExportSiteContactsResponse,
  service: {
    typeName: "fingertip.creator.site_contact.v1.SiteContactService"
  }
};
